import React from 'react';
import { Container, Row, Col } from 'react-grid-system';

// import {
//   AiOutlineCopyright,
//   AiOutlineInstagram,
//   AiOutlineTwitter,
// } from 'react-icons/ai';

// import { FaLinkedinIn, FaGithub } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className='footer'>
      <Container>
        <Row>
          <Col md={6}>
            <div className='footer__col'>
              <div>
                <img src={require('../assets/images/imagehivebeta.png')} alt='img'style={{width: "200px"}} />
              </div>
              <p style={{ width: '70%' }}>
              Our goal is delivering the smallest bit of color from an image in HEX & RGB as fast as possible, empowering you to design and build amazing apps faster. <br /><br />Created by <a href ="https://twitter.com/developerayo" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none", color: "#ED4DD8"}}>Shodipo Ayomide (@developerayo)</a> 
              </p>
            </div>
          </Col>
          <Col md={3}>
            <div className='footer__col'>
              <h4>ImageHive</h4>
              <p>About</p>
              <p>Privacy Policy</p>
            </div>
          </Col>
          <Col md={3}>
            <div className='footer__col'>
              <h4>Other Tools</h4>
              <p>Coming Soon!</p>
              {/* <p>Generate Gradient</p> 
              <p>Generate Branding Colors</p>
              <p>Resize Photos</p>
              <p>Download Videos from Youtube</p> */}
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}></Col>
          {/* <div className='footer__foot'>
            <Row>
             
                    <div className='footer__foot--copyright' style={{display: ""}}>
                      <AiOutlineCopyright /> {new Date().getFullYear()} |&nbsp;<a href="https://twitter.com/developerayo" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none"}}>Shodipo Ayomide</a>
                    </div>
                    
              <Col md={6}>
                <div className='footer__foot--icons'>
                <div>
                  <a href="https://twitter.com/developerayo" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none", color: "white"}}><AiOutlineTwitter /></a>
                  </div>
                  <div>
                  <a href="https://github.com/developerayo" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none", color: "white"}}><FaGithub /></a>
                  </div>
                  <div>
                  <a href="https://instagram.com/developerayo" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none", color: "white"}}><AiOutlineInstagram /></a>
                  </div>
                  <div>
                  <a href="https://www.linkedin.com/in/shodipo-ayomide/" target="_blank" rel="noopener noreferrer" style={{textdecoration: "none", color: "white"}}><FaLinkedinIn /></a>
                  </div>
                </div>
              </Col>
            </Row>
          </div>*/}
        </Row>
      </Container>
    </div> 
  );
};

export default Footer;
